import React from 'react';
import type { VehicleHistoryReport } from '../../types';
import { Wrapper, SpecWrapper } from './NonAudiOverview.styles';
import Carfax from '../Carfax';
import { Layout, LayoutItem, Divider } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_450, SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-common';
import type { CarSpecs, RegularSpecs } from '../../types/nonAudiSpecs';
import SpecsTitle from './SpecsTitle';
import SpecsContent from './SpecsContent';
import MpgContent from './MpgContent';

interface NonAudiOverViewProps {
  market: string;
  nonAudiSpecs: CarSpecs | undefined;
  vehicleHistoryReports: VehicleHistoryReport[] | null | undefined;
}

const NonAudiOverview: React.FC<NonAudiOverViewProps> = ({
  market,
  nonAudiSpecs,
  vehicleHistoryReports,
}) => {
  const regSpecs = nonAudiSpecs?.regularSpecs;
  const regKeys = regSpecs ? Object.keys(regSpecs) : [];
  const isUsedCAN = market === 'cauc';
  if (!regSpecs && !nonAudiSpecs?.MPG) return null;
  const MpgSpecs = nonAudiSpecs.MPG;

  return (
    <Wrapper>
      <Layout direction="column" rowGap={SYS_SPACE_FIXED_450}>
        <LayoutItem>
          <Layout columnGap={SYS_SPACE_FIXED_450} rowGap={SYS_SPACE_FIXED_450} wrap="wrap">
            {!!regSpecs &&
              regKeys.map((item) => {
                const { iconName, value } = regSpecs[item as keyof RegularSpecs];
                const amount = regSpecs[item as keyof RegularSpecs].amount;
                return (
                  <SpecWrapper data-testid={`spec-wrapper-${item}`} key={item}>
                    <LayoutItem>
                      <SpecsTitle iconName={iconName} specId={item} />
                    </LayoutItem>
                    <LayoutItem>
                      <SpecsContent value={value} amount={amount} specId={item} />
                    </LayoutItem>
                  </SpecWrapper>
                );
              })}
            <SpecWrapper key="MPG" isResponsive data-testid={`spec-wrapper-MPG`}>
              <LayoutItem>
                <Layout direction="column" columnGap={SYS_SPACE_FIXED_50}>
                  <SpecsTitle iconName="fuel-range" specId="MPG.title" />
                </Layout>
              </LayoutItem>
              <Layout direction="row" align="center" justify="space-between">
                <LayoutItem key="highway">
                  <MpgContent value={MpgSpecs.highway} specId="highway" />
                </LayoutItem>
                <Divider key="highway-divider" orientation="vertical" />
                <LayoutItem key="city">
                  <MpgContent value={MpgSpecs.city} specId="city" />
                </LayoutItem>
                <Divider key="city-divider" orientation="vertical" />
                <LayoutItem key="combined">
                  <MpgContent value={MpgSpecs.combined} specId="combined" />
                </LayoutItem>
              </Layout>
            </SpecWrapper>
          </Layout>
        </LayoutItem>
        <LayoutItem>
          <Carfax isCanadian={isUsedCAN} vehicleHistoryReports={vehicleHistoryReports} />
        </LayoutItem>
      </Layout>
    </Wrapper>
  );
};

export default NonAudiOverview;
